export default "__VITE_ASSET__BVR6Ic_h__"